import { FC } from 'react';

interface ISvgProps {}

export const ImageAttachmentIcon: FC<ISvgProps> = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18 16.5156V2.51562C18 1.41562 17.1 0.515625 16 0.515625H2C0.9 0.515625 0 1.41562 0 2.51562V16.5156C0 17.6156 0.9 18.5156 2 18.5156H16C17.1 18.5156 18 17.6156 18 16.5156ZM5.9 11.4956L8 14.0256L11.1 10.0356C11.3 9.77563 11.7 9.77562 11.9 10.0456L15.41 14.7256C15.66 15.0556 15.42 15.5256 15.01 15.5256H3.02C2.6 15.5256 2.37 15.0456 2.63 14.7156L5.12 11.5156C5.31 11.2556 5.69 11.2456 5.9 11.4956Z"
				fill="#5977EB"
			/>
		</svg>
	);
};
